<template>
    <ul id="list-tasks">
        <li>
            <div class="fv ct" style="width: 210px; height: 120px; border-width: 1px; border: 1px solid #dddddd;
                                        background: #ffffff; box-shadow: 2px 2px 4px #dddddd;  
                                            -webkit-box-shadow: 2px 2px 4px #dddddd; -moz-box-shadow: 2px 2px 4px #dddddd; 
                                        border-radius: 10px">
                <div class="fh cc" style="text-align: center; width: 90%; height:25%; font-size: 12px; color: #5c666f; 
                                          font-weight: 600"> 
                    {{item.Nombre}} 
                </div>  
                <div class="fh cc" style="width: 100%; height:75%"> 
                    <div class="fh cc" style="width: 40%; height:100%"> 
                        <img id="imagenProducto" :src="imagenProducto" style="width: 80%" /> 
                    </div>  
                    <div class="fv lb" style="width: 60%; height:100%; margin-left: 10px"> 
                        <div class="fv lt" style="width: 100%; height: 40px" v-show='showPrecioNormal'> 
                            <div style="font-size: 10px ;font-weight: 400; margin-top: 5px">Precio normal:</div>
                            <div style="font-size: 10px ;font-weight: 400; text-decoration:line-through">{{moneyLabel}}{{precioHabComp | formatMoney}} </div>
                        </div>  
                        <div class="fv lt" style="width: 100%; height: 40px"> 
                            <div class="fh lt" style="width: 100%;margin-top: 0px"> 
                                <div style="font-size: 10px ;font-weight: 500; ">Promoción:</div>
                                <div style="font-size: 10px ;font-weight: 500; color: #aaaaaa; margin-left: 2px">{{porcentajeDescuento}}</div>
                            </div>  
                            <div style="font-size: 10px ;font-weight: 500">{{moneyLabel}}{{precioPromoComp | formatMoney}} </div>
                        </div>  
                    </div>  
                </div>  
            </div>
        </li>
    </ul>
</template>

 
<script>
  import axios from 'axios'

  export default {
    name: 'item-promocionesHome',
    props: ['item'],

    data() {
      return {
        showPrecioNormal:true,
      }
    },

    computed: {
      moneyLabel() {
        if (this.item.Moneda == 2) {
          return 'U$S ' 
        }
        else {
          return '$ ' 
        }
      },
      precioHabComp() {
        return (this.conversionMonedaProducto(this.item.PrecioHabitual)).toFixed(2)
      }, 
      precioPromoComp() {
        return (this.conversionMonedaProducto(this.item.PrecioPromocional)).toFixed(2)
      }, 
      porcentajeDescuento() {
        if (this.item.DescuentoPorcentaje > 0) {
          this.showPrecioNormal = true
          //return '(-' + Math.round(this.item.DescuentoPorcentaje) + '%)'
          return '(-' + this.item.DescuentoPorcentaje + '%)'
        }
        else {
          this.showPrecioNormal = false
          return ''
        }
      },
      imagenProducto() {
        if (this.item.ImagenUrl != null) {
          return this.item.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        }
      } 
    },


    methods: {
      clickOblea () {
        this.$router.push({ name: 'promociones' });
      },
      conversionMonedaProducto(monto) {
        var montoConv = 0.0
        if (this.$store.state.pedido.idMoneda != this.$store.state.user.cliente.ListaPrecioMoneda) {
            if (this.$store.state.pedido.idMoneda == 2) {
                montoConv  = monto / this.$store.state.user.usuario.CotizacionDolar
            }
            else if (this.$store.state.pedido.idMoneda == 1) {
                montoConv  = monto * this.$store.state.user.usuario.CotizacionDolar
            }
        }
        else {
            montoConv  = monto 
        }
        return montoConv
      }
    }

  }
</script>


<style scoped>

  * {
   margin:  0;
   padding: 0;
  }
        
  li {
   float: left;
   display: block;
   padding-right: 20px;
   text-decoration: none;
  }

.oblea:hover{
    cursor: pointer;
  }      
        
        
</style>


// WEBPACK FOOTER //
// src/components/views/home/itemPromocionHome.vue